// Use this to check keys.
// Run the audio script to save out the
import soundData from "../../../static/assets/sound/result.json";

const random = new Phaser.Math.RandomDataGenerator("test");
const playedThisTurn: Map<string, number> = new Map();

export enum MusicOptions {
  city = "city_music",
  sky = "sky_music",
  stars = "stars_music",
}

export class SoundPlayer {
  private static musicPlaying: MusicOptions | null;
  public static isMusicMuted: boolean;

  static clearPlayedThisTurn() {
    playedThisTurn.clear();
  }

  static loadAudio(scene: Phaser.Scene) {
    scene.load.audioSprite("sfx", "assets/sound/result.json", [
      "assets/sound/result.ogg",
      "assets/sound/result.m4a",
      "assets/sound/result.mp3",
      "assets/sound/result.ac3",
    ]);
  }

  static playBlip(scene: Phaser.Scene) {
    scene.sound.playAudioSprite(
      "sfx",
      `blip${Math.floor(Math.random() * 4) + 1}`,
      {
        volume: Math.random() * 0.1 + 0.1,
        rate: 0.9 + Math.random() * 0.2,
      }
    );
  }

  static pushMonsterSFX(scene: Phaser.Scene) {
    // scene.sound.playAudioSprite(
    //   "sfx",
    //   `push_monster_${Math.floor(Math.random() * 8) + 1}`,
    //   {
    //     volume: Math.random() * 0.1 + 0.2,
    //   }
    // );
    scene.sound.playAudioSprite(
      "sfx",
      `monster_push${random.integerInRange(1, 2)}`,
      {
        volume: Math.random() * 0.1 + 0.15,
      }
    );
  }

  static cratePushSFX(scene: Phaser.Scene) {
    // scene.sound.playAudioSprite(
    //   "sfx",
    //   `push_monster_${Math.floor(Math.random() * 8) + 1}`,
    //   {
    //     volume: Math.random() * 0.1 + 0.2,
    //   }
    // );
    scene.sound.playAudioSprite(
      "sfx",
      `monster_push${random.integerInRange(1, 2)}`,
      {
        volume: 0.1,
        detune: random.integerInRange(0, 10),
      }
    );
  }

  static playerMoveSFX(scene: Phaser.Scene) {
    const number = Math.floor(Math.random() * 16) + 1;
    // scene.sound.playAudioSprite(
    //   "sfx",
    //   `player_move_${("00" + number).substr(-2, 2)}`,
    //   {
    //     volume: Math.random() * 0.1 + 0.2,
    //   }
    // );
    scene.sound.playAudioSprite(
      "sfx",
      `player_walk${random.integerInRange(1, 3)}`,
      {
        volume: Math.random() * 0.1 + 0.2,
      }
    );
    // soundData.spritemap.player_walk1;
  }

  static playerTurnSFX(scene: Phaser.Scene) {
    const number = Math.floor(Math.random() * 16) + 1;
    // scene.sound.playAudioSprite(
    //   "sfx",
    //   `player_turn_${("00" + number).substr(-2, 2)}`,
    //   {
    //     volume: Math.random() * 0.1 + 0.2,
    //   }
    // );
    scene.sound.playAudioSprite("sfx", `player_turn1`, {
      volume: 0.4,
    });
  }

  static playerBumpSFX(scene: Phaser.Scene) {
    const number = Math.floor(Math.random() * 8) + 1;
    scene.sound.playAudioSprite("sfx", `player_bump2_${number}`, {
      volume: Math.random() * 0.1 + 0.2,
    });
  }

  static monsterJumpSFX(scene: Phaser.Scene, volume = 0.15) {
    scene.sound.playAudioSprite("sfx", `monster_move${2}`, {
      volume: Math.random() * 0.1 + volume,
    });
  }

  static playerShootSFX(scene: Phaser.Scene) {
    scene.sound.playAudioSprite("sfx", `player_shot`, {
      volume: Math.random() * 0.1 + 0.15,
    });
  }

  static doorChangeUpSFX(scene: Phaser.Scene) {
    const playNumber: number | undefined = playedThisTurn.get(
      "doorChangeUpSFX"
    );
    if (playNumber === undefined) {
      playedThisTurn.set("doorChangeUpSFX", 1);
    } else {
      playedThisTurn.set("doorChangeUpSFX", playNumber + 1);
      if (playNumber > 1) {
        return;
      }
    }
    scene.sound.playAudioSprite("sfx", `door_change_up1`, {
      volume: Math.random() * 0.1 + 0.15,
    });
  }

  static doorChangeDownSFX(scene: Phaser.Scene) {
    const playNumber: number | undefined = playedThisTurn.get(
      "doorChangeDownSFX"
    );
    if (playNumber === undefined) {
      playedThisTurn.set("doorChangeDownSFX", 1);
    } else {
      playedThisTurn.set("doorChangeDownSFX", playNumber + 1);
      if (playNumber > 1) {
        return;
      }
    }

    scene.sound.playAudioSprite("sfx", `door_change_down1`, {
      volume: Math.random() * 0.1 + 0.1,
    });
  }

  static crateBreakSFX(scene: Phaser.Scene) {
    scene.sound.playAudioSprite(
      "sfx",
      `crate_break${random.integerInRange(1, 2)}`,
      {
        volume: Math.random() * 0.1 + 0.4,
      }
    );
  }

  static meleeBreakSFX(scene: Phaser.Scene) {
    scene.sound.playAudioSprite("sfx", `monster_die1`, {
      volume: Math.random() * 0.1 + 0.55,
    });
  }

  static clickSFX(scene: Phaser.Scene, volume = 0.25) {
    scene.sound.playAudioSprite(
      "sfx",
      `undo_click${random.integerInRange(1, 4)}`,
      {
        volume,
      }
    );
  }

  static mirrorBounceSFX(scene: Phaser.Scene) {
    scene.sound.playAudioSprite("sfx", `mirror_bounce1`, {
      volume: Math.random() * 0.1 + 0.1,
    });
  }

  static endLevelSFX(scene: Phaser.Scene) {
    scene.sound.playAudioSprite("sfx", `end_level1`, {
      volume: 0.5,
    });
  }
  static enterLevelSFX(scene: Phaser.Scene) {
    scene.sound.playAudioSprite("sfx", `enter_level1`, {
      volume: 0.8,
    });
  }
  static laserToggleSFX(scene: Phaser.Scene) {
    scene.sound.playAudioSprite("sfx", `toggle_hit1`, {
      volume: 0.8,
    });
  }

  static chunkUnlockSFX(scene: Phaser.Scene) {
    scene.sound.playAudioSprite("sfx", "unlock_chunk_whine", {
      volume: 0.8,
    });
    this.enterLevelSFX(scene);
  }

  static titleStartSFX(scene: Phaser.Scene) {
    scene.sound.playAudioSprite("sfx", "title_start_song", {
      volume: 0.8,
    });
  }

  static unlockLevelSFX(scene: Phaser.Scene) {
    scene.sound.playAudioSprite("sfx", "unlock_level_boom", {
      volume: 0.6,
    });
  }

  static worldBoomSFX(scene: Phaser.Scene) {
    scene.sound.playAudioSprite("sfx", "unlock_level_boom", {
      volume: 0.6,
    });
  }

  static switchSong(scene: Phaser.Scene, music: MusicOptions) {
    if (music === SoundPlayer.musicPlaying) {
      return;
    } else {
      SoundPlayer.musicPlaying = music;
    }
    const toStop = (
      scene.sound?.sounds || []
    ).filter(({ currentMarker: { name } }) =>
      [MusicOptions.city, MusicOptions.sky, MusicOptions.stars].includes(name)
    );

    for (const playingSound of toStop) {
      if (playingSound && typeof playingSound.stop === "function") {
        playingSound.stop();
      }
    }

    scene.sound.playAudioSprite("sfx", music, {
      loop: true,
      volume: SoundPlayer.isMusicMuted ? 0 : 0.35,
    });
  }

  static toggleAudioMute(scene: Phaser.Scene) {
    SoundPlayer.isMusicMuted = !SoundPlayer.isMusicMuted;
    const toMute = (
      scene.sound?.sounds || []
    ).filter(({ currentMarker: { name } }) =>
      [MusicOptions.city, MusicOptions.sky, MusicOptions.stars].includes(name)
    );

    for (const playingSound of toMute) {
      if (playingSound && typeof playingSound.volume === "number") {
        playingSound.volume = SoundPlayer.isMusicMuted ? 0 : 0.35;
      }
    }
  }
}

SoundPlayer.isMusicMuted = false;
